let loadPromise = null;

function pdfAssetUrl(filename) {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return `${window.location.origin}/${filename}`;
  }
  const base =
    typeof process !== "undefined" && process.env && process.env.BASE_URL
      ? process.env.BASE_URL
      : "/";
  return `${base}${filename}`;
}

function loadPdfJs() {
  if (typeof window !== "undefined" && window.pdfjsLib) {
    window.pdfjsLib.GlobalWorkerOptions.workerSrc = pdfAssetUrl("pdf.worker.min.js");
    return Promise.resolve(window.pdfjsLib);
  }
  if (loadPromise) {
    return loadPromise;
  }
  loadPromise = new Promise((resolve, reject) => {
    if (typeof document === "undefined") {
      reject(new Error("pdf.js requires a browser"));
      return;
    }
    const script = document.createElement("script");
    script.src = pdfAssetUrl("pdf.min.js");
    script.async = true;
    script.onload = () => {
      if (!window.pdfjsLib) {
        reject(new Error("pdf.js failed to load"));
        return;
      }
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = pdfAssetUrl("pdf.worker.min.js");
      resolve(window.pdfjsLib);
    };
    script.onerror = () => reject(new Error("pdf.js failed to load"));
    document.head.appendChild(script);
  }).catch((error) => {
    loadPromise = null;
    throw error;
  });
  return loadPromise;
}

export async function getPdfDocument(source) {
  const pdfjsLib = await loadPdfJs();
  return pdfjsLib.getDocument(source).promise;
}

export async function renderPdfPagesToContainer(pdf, container, cssWidth) {
  if (!pdf || !container || !cssWidth) return;

  container.innerHTML = "";
  const dpr =
    typeof window !== "undefined" && window.devicePixelRatio
      ? window.devicePixelRatio
      : 1;

  for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber += 1) {
    const page = await pdf.getPage(pageNumber);
    const unscaled = page.getViewport({ scale: 1 });
    const scale = (cssWidth / unscaled.width) * dpr;
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement("canvas");
    canvas.setAttribute("data-testid", `file-preview-pdf-page-${pageNumber}`);
    canvas.width = Math.max(1, Math.floor(viewport.width));
    canvas.height = Math.max(1, Math.floor(viewport.height));
    canvas.style.display = "block";
    canvas.style.width = "100%";
    canvas.style.height = "auto";
    const context = canvas.getContext("2d");
    await page.render({ canvasContext: context, viewport }).promise;
    container.appendChild(canvas);
  }
}
